import BaseService from "../baseService";
class Auth extends BaseService {
  constructor(id) {
    const resource = "auth/";
    let relationship = {};
    super(id, relationship, resource);
  }
}

export default (id) => new Auth(id);
